import React from 'react'

import Container from './container'

export default Container
